import { render, staticRenderFns } from "./Statictics.vue?vue&type=template&id=4ed649c2&scoped=true&"
import script from "./Statictics.vue?vue&type=script&lang=js&"
export * from "./Statictics.vue?vue&type=script&lang=js&"
import style0 from "./Statictics.vue?vue&type=style&index=0&id=4ed649c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed649c2",
  null
  
)

export default component.exports